import React from "react";
import style from "./RiskAssessmentDetailPanel.module.scss";
import { Button } from "../../../primary";
import { Spinner } from "../../../secondary/Loader/Spinner";
import { getOptionLabel } from "./utils/riskAssessment.utils";
import { RiskAssessmentScalePanel } from "./RiskAssessmentScalePanel";
import { Disclaimer } from "../components/Disclaimer";
import { DISCLAIMER_TEXT } from "../ProductSelector/utils";

export const RiskAssessmentDetailPanel = ({
  assessmentName,
  fields,
  formData,
  score,
  loading,
  onEdit,
  successMessage,
  showNameInput,
  pendingName,
  setPendingName,
  saveAssessmentLoading,
  emailLoading,
  handleCancelName,
  handleConfirmName,
  handleEmailRiskAssessment,
  handleSaveRiskAssessment,
}) => {
  return (
    <div className={style.scalePanel}>
      <div className={style.scaleHeader}>
        <div>
          <h2 className={style.panelTitle}>{assessmentName || "Risk Assessment"}</h2>
          <p className={style.panelSubtitle}>Braden Score : {score}</p>
        </div>
        <Button type="button" classes={{ className: `${style.edit_icon_btn}` }} onClick={onEdit}>
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </Button>
      </div>

      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className={style.grid}>
            {fields.map((field) => (
              <div className={style.field} key={field.name}>
                <span className={style.label}>{field.label}:</span>{" "}
                <span className={style.readonlyValue}>{getOptionLabel(field, formData[field.name])}</span>
              </div>
            ))}
          </div>

          <div className={style.divider} />

          <RiskAssessmentScalePanel
            score={score}
            successMessage={successMessage}
            showNameInput={showNameInput}
            pendingName={pendingName}
            setPendingName={setPendingName}
            saveAssessmentLoading={saveAssessmentLoading}
            emailLoading={emailLoading}
            onCancelName={handleCancelName}
            onConfirmName={handleConfirmName}
            onEmailRiskAssessment={handleEmailRiskAssessment}
            onSaveRiskAssessment={handleSaveRiskAssessment}
          />

          <Disclaimer>{DISCLAIMER_TEXT}</Disclaimer>
        </>
      )}
    </div>
  );
};

export default RiskAssessmentDetailPanel;
